// An id moved one place (the arrow keys); null at an edge or for an id that is not in the list.
export function moveBy(ids: string[], id: string, delta: number): string[] | null {
	const from = ids.indexOf(id);
	const to = from + delta;
	if (from < 0 || to < 0 || to >= ids.length) return null;
	const next = [...ids];
	next.splice(from, 1);
	next.splice(to, 0, id);
	return next;
}

// An id dropped before or after another (a drag over a row's top or bottom half); the same list when nothing moves.
export function placeNear(ids: string[], id: string, over: string, after: boolean): string[] {
	if (id === over || !ids.includes(id) || !ids.includes(over)) return ids;
	const rest = ids.filter((entry) => entry !== id);
	rest.splice(rest.indexOf(over) + (after ? 1 : 0), 0, id);
	return rest.every((entry, index) => entry === ids[index]) ? ids : rest;
}

// A preview order is only good for the very ids on screen, so a row that came or went meanwhile ends it.
export function sameMembers(a: string[], b: string[]): boolean {
	return a.length === b.length && a.every((id) => b.includes(id));
}

// Whether a released drag writes: only while the ids on screen are still the ones it began on, and the order moved or the caller counts the drop.
export function dropWrites(start: string[], live: string[], dropped: string[], counts: () => boolean): boolean {
	if (live.length !== start.length || live.some((id, index) => id !== start[index])) return false;
	return dropped.some((id, index) => id !== start[index]) || counts();
}
